import React from "react";

import ContactForm from "../components/ContactForm";
import ContactSocial from "../components/ContactSocial";
import ScrollTop from "../components/ScrollTop";

const ContactUs = () => {
  return (
    <>
      <ContactForm />
      <ContactSocial />
      <ScrollTop />
    </>
  );
};

export default ContactUs;
